// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.fleet-health-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 16px;
}

.fh-row {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 12px;
  gap: 12px;
  align-items: stretch;
}

.fh-row-score {
  height: 230px;
  max-height: 230px;
}

.fh-row-kpi {
  height: 300px;
  max-height: 300px;
}

.fh-row-lists {
  height: 270px;
  max-height: 270px;
}

.fh-row > .fh-card {
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

.fh-card {
  background: #fff;
  border: 1px solid #e3e7eb;
  border-radius: 6px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.fh-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.fh-card-title {
  margin: 0 0 2px;
  font-size: 13.5px;
  font-weight: 700;
  color: #22303c;
}

.fh-card-sub {
  color: #8a97a3;
  font-size: 11px;
  margin-bottom: 6px;
}

.fh-card-head-action {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
}

.fh-search-input {
  width: 100%;
  max-width: 220px;
  padding: 5px 10px;
  border: 1px solid #e3e7eb;
  border-radius: 4px;
  font-size: 12px;
  color: #22303c;
  background: #fff;
  box-sizing: border-box;
}

.fh-search-input::placeholder {
  color: #8a97a3;
  opacity: 1;
}

.fh-search-input::-webkit-input-placeholder {
  color: #8a97a3;
  opacity: 1;
}

.fh-search-input::-moz-placeholder {
  color: #8a97a3;
  opacity: 1;
}

.fh-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef1f4;
  color: #6b7883;
  white-space: nowrap;
}

.fh-card-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.fh-card-footer {
  margin-top: auto;
}

.fh-span-3 {
  grid-column: span 3;
}

.fh-span-4 {
  grid-column: span 4;
}

.fh-span-5 {
  grid-column: span 5;
}

.fh-span-7 {
  grid-column: span 7;
}

.fh-span-12 {
  grid-column: span 12;
}

.fh-metaline {
  display: flex;
  justify-content: space-between;
  font-size: 11.5px;
  color: #6b7883;
  padding: 5px 0;
  border-top: 1px dashed #e3e7eb;
}

.fh-metaline b {
  color: #22303c;
  font-weight: 600;
}

.fh-metaline .flag,
.fh-flag {
  color: #e0484c;
}

.fh-kpi {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.15;
  color: #22303c;
}

.fh-kpi small {
  font-size: 13px;
  font-weight: 600;
  color: #8a97a3;
  margin-left: 4px;
}

.fh-delta {
  font-size: 11.5px;
  font-weight: 600;
}

.fh-delta.up {
  color: #e0484c;
}

.fh-delta.down {
  color: #3f9c40;
}

.fh-track {
  height: 6px;
  background: #eef1f4;
  border-radius: 3px;
  overflow: hidden;
}

.fh-fill {
  height: 100%;
  border-radius: 3px;
}

.fh-note {
  margin-top: 10px;
  font-size: 11.5px;
  line-height: 1.5;
  color: #4a5a66;
  background: #f4f9f4;
  border-left: 3px solid #5cb85c;
  padding: 8px 10px;
  border-radius: 0 3px 3px 0;
}

.fh-btn {
  background: #5cb85c;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 18px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.fh-btn:hover {
  background: #3f9c40;
}

.fh-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  background: #7aa86a;
}

.fh-btn:disabled:hover {
  background: #7aa86a;
}

.fh-btn.ghost {
  background: #fff;
  color: #1c6fae;
  border: 1px solid #e3e7eb;
}

.fh-btn.ghost:hover {
  background: #f5f8fa;
}

.fh-btn.sm {
  padding: 5px 12px;
  font-size: 11px;
}

.fh-seg {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}

.fh-seg button {
  flex: 1 1;
  padding: 6px 0;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e3e7eb;
  background: #fff;
  color: #5c6a76;
}

.fh-seg button.on {
  background: #2b3945;
  color: #fff;
  border-color: #2b3945;
}

.fh-bar-row {
  margin-bottom: 9px;
}

.fh-bar-row-clickable {
  cursor: pointer;
  border-radius: 4px;
  padding: 4px 4px 6px;
  margin-left: -4px;
  margin-right: -4px;
}

.fh-bar-row-clickable:hover {
  background: #f5f8fa;
}

.fh-bar-top {
  display: flex;
  justify-content: space-between;
  font-size: 11.5px;
  margin-bottom: 3px;
}

.fh-legend {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 11.5px;
  color: #5c6a76;
}

.fh-legend span {
  display: flex;
  align-items: center;
  gap: 7px;
}

.fh-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.fh-camp {
  position: relative;
  background: linear-gradient(155deg, #24313d 0%, #3a5163 55%, #466275 100%) !important;
  color: #fff !important;
  border: none !important;
  overflow: hidden;
}

.fh-camp .fh-card-title,
.fh-camp .fh-card-sub {
  color: #fff !important;
}

.fh-camp .fh-card-sub {
  opacity: 0.65;
}

.fh-camp-slider {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  flex: 1 1;
  min-height: 0;
  animation: fhCampFade 0.35s ease;
}

@keyframes fhCampFade {
  from {
    opacity: 0.35;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
/* Fixed image slot on the right; remaining width for text */
.fh-camp-hero {
  position: relative;
  flex: 0 0 300px;
  width: 300px;
  height: 200px;
  min-width: 300px;
  min-height: 200px;
  max-width: 300px;
  max-height: 200px;
  align-self: center;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(135deg, #4d6578, #2f4252);
}

.fh-camp-hero img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
}

.fh-camp-hero-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.55);
  background: radial-gradient(circle at 30% 30%, rgba(143, 209, 143, 0.25), transparent 55%), linear-gradient(135deg, #4d6578, #2f4252);
}

.fh-camp-cat {
  display: inline-flex;
  align-self: flex-start;
  padding: 3px 9px;
  border-radius: 999px;
  background: rgba(20, 28, 36, 0.72);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #b7e0b7;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fh-camp .fh-card-head {
  align-items: center;
  margin-bottom: 6px;
}

.fh-camp .fh-card-head-action {
  flex: 0 0 auto;
  margin-left: auto;
}

.fh-camp-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(20, 28, 36, 0.65);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.fh-camp-arrow:hover {
  background: rgba(20, 28, 36, 0.9);
}

.fh-camp-arrow.left {
  left: 4px;
}

.fh-camp-arrow.right {
  right: 4px;
}

.fh-camp-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-start;
  overflow: hidden;
}

.fh-camp-slide-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 4px;
  flex: 0 0 auto;
}

.fh-camp-desc {
  margin: 0 0 8px;
  font-size: 11.5px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.72);
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-word;
  white-space: pre-wrap;
  overscroll-behavior: contain;
}
.fh-camp-desc::-webkit-scrollbar {
  width: 3px;
}
.fh-camp-desc::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.28);
  border-radius: 3px;
}

.fh-camp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
  flex: 0 0 auto;
  margin-top: auto;
}

.fh-camp-chip {
  font-size: 10.5px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.92);
}

.fh-camp-dots {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
}

.fh-camp-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: rgba(255, 255, 255, 0.28);
  cursor: pointer;
  transition: width 0.2s ease, background 0.2s ease;
}

.fh-camp-dot.on {
  background: #8fd18f;
  width: 16px;
  border-radius: 999px;
}

.fh-camp-cta {
  margin-top: auto;
  width: 100%;
}

.fh-camp ul {
  list-style: none;
  margin: 8px 0 10px;
  padding: 0;
  font-size: 12px;
}

.fh-camp li {
  padding: 4px 0;
}

.fh-camp li::before {
  content: "✓";
  color: #8fd18f;
  font-weight: 700;
  margin-right: 8px;
}

.fh-veh {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 0;
  border-top: 1px solid #e3e7eb;
}

.fh-veh:first-of-type {
  border-top: none;
}

.fh-plate {
  font-family: Consolas, monospace;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid #e3e7eb;
  border-radius: 3px;
  padding: 4px 8px;
  background: #fbfcfd;
  min-width: 84px;
  text-align: center;
}

.fh-plate.used {
  border-color: #cbe6cb;
  background: #f2f9f2;
  color: #3f9c40;
}

.fh-sev {
  width: 6px;
  height: 34px;
  border-radius: 3px;
  flex: none;
}

.fh-empty {
  color: #8a97a3;
  font-size: 12px;
  padding: 12px 0;
  text-align: center;
}

.fh-coming-soon {
  font-size: 11px;
  color: #8a97a3;
  background: #f5f7f9;
  border: 1px dashed #d5dde5;
  border-radius: 4px;
  padding: 8px 10px;
  margin-top: 8px;
  text-align: center;
}

@media (max-width: 1250px) {
  .fh-row-score,
  .fh-row-kpi,
  .fh-row-lists {
    height: auto;
    max-height: none;
  }
  .fh-row > .fh-card {
    max-height: none;
  }
  .fh-row-lists > .fh-card {
    max-height: 320px;
  }
  .fh-span-3,
  .fh-span-4,
  .fh-span-5 {
    grid-column: span 6;
  }
  .fh-span-7 {
    grid-column: span 12;
  }
}
@media (max-width: 768px) {
  .fh-row-lists > .fh-card {
    max-height: 300px;
  }
  .fh-span-3,
  .fh-span-4,
  .fh-span-5,
  .fh-span-7 {
    grid-column: span 12;
  }
}
/* Push footer meta rows to the bottom of equal-height cards */
.fh-row-score .fh-metaline:first-of-type {
  margin-top: auto;
}

/* KPI row: shared visual + meta alignment across 4 cards */
.fh-row-kpi .fh-card-head {
  min-height: 44px;
}

.fh-row-kpi .fh-card-sub {
  min-height: 28px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0;
}

.fh-row-kpi .fh-kpi-visual {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.fh-row-kpi .fh-kpi-visual--stack {
  align-items: stretch;
  justify-content: center;
  width: 100%;
}

.fh-row-kpi .fh-kpi-visual--stack .fh-kpi {
  font-size: 26px;
}

.fh-row-kpi .fh-kpi-spark {
  width: 100%;
  margin-top: 8px;
  flex: 0 0 auto;
}

.fh-row-kpi .fh-kpi-range {
  display: flex;
  justify-content: space-between;
  font-size: 10.5px;
  color: #8a97a3;
  margin-top: 6px;
}

.fh-row-kpi .fh-kpi-meta {
  margin-top: auto;
  flex-shrink: 0;
  width: 100%;
}

.fh-row-kpi .fh-legend {
  width: 100%;
}

.fh-veh-list,
.fh-maint-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.fh-row-score .fh-card-body,
.fh-row-kpi .fh-card-body,
.fh-row-lists .fh-card-body {
  overflow: hidden;
}

.fh-row-lists .fh-camp-slider,
.fh-row-score .fh-camp-slider {
  overflow: hidden;
}

.fh-row-lists .fh-camp-hero,
.fh-row-score .fh-camp-hero {
  flex: 0 0 300px;
  width: 300px;
  height: 200px;
}

@media (max-width: 768px) {
  .fh-camp-slider {
    flex-direction: column;
  }
  .fh-camp-hero {
    flex: 0 0 300px;
    width: 300px;
    height: 200px;
    align-self: flex-end;
  }
}
.fh-row-score .fh-kpi {
  font-size: 26px;
}

.fh-row-score .fh-metaline {
  padding: 4px 0;
}

.fh-row-score .fh-score-layout {
  flex: 1 1;
  min-height: 0;
  display: flex;
  gap: 14px;
  align-items: center;
}

.fh-row-score .fh-score-bars {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

/* PM Compliance — 2 metrics per row */
.fh-pm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
  column-gap: 10px;
}

.fh-pm-grid .fh-metaline {
  min-width: 0;
  gap: 4px;
  padding: 4px 0;
}

.fh-pm-grid .fh-metaline span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/Pages/FleetHealth/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sCAAA;EACA,cAAA;EAAA,SAAA;EACA,oBAAA;AAEF;;AACA;EACE,aAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AACA;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEF;;AACA;EACE,cAAA;EACA,UAAA;AAEF;;AACA;EACE,cAAA;EACA,UAAA;AAEF;;AACA;EACE,cAAA;EACA,UAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACE,oBAAA;AAMF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,8BAAA;AAMF;;AAHA;EACE,cAAA;EACA,gBAAA;AAMF;;AAHA;;EAEE,cAAA;AAMF;;AAHA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAMF;;AAHA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAMF;;AAHA;EACE,iBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,cAAA;AAMF;;AAHA;EACE,cAAA;AAMF;;AAHA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,YAAA;EACA,kBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,0BAAA;AAMF;;AAHA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,iBAAA;EACA,eAAA;AAMF;;AAHA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAMF;;AAHA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AAMF;;AAHA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAMF;;AAHA;EACE,kBAAA;AAMF;;AAHA;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AAMF;;AAHA;EACE,mBAAA;AAMF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAMF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAMF;;AAHA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAMF;;AAHA;;EAEE,sBAAA;AAMF;;AAHA;EACE,aAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AAMF;;AAHA;EACE;IACE,aAAA;IACA,0BAAA;EAMF;EAJA;IACE,UAAA;IACA,eAAA;EAMF;AACF;AAHA,4DAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qDAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,qIACE;AAIJ;;AAAA;EACE,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAGF;;AAAA;EACE,mBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,cAAA;EACA,iBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAGF;;AAAA;EACE,iCAAA;AAGF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;AAGF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;AAGF;AADE;EACE,UAAA;AAGJ;AAAE;EACE,qCAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,0BAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,eAAA;EACA,iDAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE;;;IAGE,YAAA;IACA,gBAAA;EACF;EAEA;IACE,gBAAA;EAAF;EAGA;IACE,iBAAA;EADF;EAIA;;;IAGE,mBAAA;EAFF;EAIA;IACE,oBAAA;EAFF;AACF;AAKA;EACE;IACE,iBAAA;EAHF;EAMA;;;;IAIE,oBAAA;EAJF;AACF;AAOA,8DAAA;AACA;EACE,gBAAA;AALF;;AAQA,2DAAA;AACA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AALF;;AAQA;EACE,oBAAA;EACA,uBAAA;EACA,WAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,WAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;;EAEE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;AALF;;AAQA;;;EAGE,gBAAA;AALF;;AAQA;;EAEE,gBAAA;AALF;;AAQA;;EAEE,eAAA;EACA,YAAA;EACA,aAAA;AALF;;AAQA;EACE;IACE,sBAAA;EALF;EAQA;IACE,eAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;EANF;AACF;AASA;EACE,eAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAPF;;AAUA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAPF;;AAUA,sCAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EAAA,gBAAA;AAPF;;AAUA;EACE,YAAA;EACA,QAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPF","sourcesContent":[".fleet-health-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 0 16px;\n}\n\n.fh-row {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 12px;\n  align-items: stretch;\n}\n\n.fh-row-score {\n  height: 230px;\n  max-height: 230px;\n}\n\n.fh-row-kpi {\n  height: 300px;\n  max-height: 300px;\n}\n\n.fh-row-lists {\n  height: 270px;\n  max-height: 270px;\n}\n\n.fh-row > .fh-card {\n  min-height: 0;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.fh-card {\n  background: #fff;\n  border: 1px solid #e3e7eb;\n  border-radius: 6px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n}\n\n.fh-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.fh-card-title {\n  margin: 0 0 2px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #22303c;\n}\n\n.fh-card-sub {\n  color: #8a97a3;\n  font-size: 11px;\n  margin-bottom: 6px;\n}\n\n.fh-card-head-action {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  min-width: 0;\n}\n\n.fh-search-input {\n  width: 100%;\n  max-width: 220px;\n  padding: 5px 10px;\n  border: 1px solid #e3e7eb;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #22303c;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.fh-search-input::placeholder {\n  color: #8a97a3;\n  opacity: 1;\n}\n\n.fh-search-input::-webkit-input-placeholder {\n  color: #8a97a3;\n  opacity: 1;\n}\n\n.fh-search-input::-moz-placeholder {\n  color: #8a97a3;\n  opacity: 1;\n}\n\n.fh-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #eef1f4;\n  color: #6b7883;\n  white-space: nowrap;\n}\n\n.fh-card-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.fh-card-footer {\n  margin-top: auto;\n}\n\n.fh-span-3 {\n  grid-column: span 3;\n}\n.fh-span-4 {\n  grid-column: span 4;\n}\n.fh-span-5 {\n  grid-column: span 5;\n}\n.fh-span-7 {\n  grid-column: span 7;\n}\n.fh-span-12 {\n  grid-column: span 12;\n}\n\n.fh-metaline {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11.5px;\n  color: #6b7883;\n  padding: 5px 0;\n  border-top: 1px dashed #e3e7eb;\n}\n\n.fh-metaline b {\n  color: #22303c;\n  font-weight: 600;\n}\n\n.fh-metaline .flag,\n.fh-flag {\n  color: #e0484c;\n}\n\n.fh-kpi {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #22303c;\n}\n\n.fh-kpi small {\n  font-size: 13px;\n  font-weight: 600;\n  color: #8a97a3;\n  margin-left: 4px;\n}\n\n.fh-delta {\n  font-size: 11.5px;\n  font-weight: 600;\n}\n\n.fh-delta.up {\n  color: #e0484c;\n}\n\n.fh-delta.down {\n  color: #3f9c40;\n}\n\n.fh-track {\n  height: 6px;\n  background: #eef1f4;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.fh-fill {\n  height: 100%;\n  border-radius: 3px;\n}\n\n.fh-note {\n  margin-top: 10px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #4a5a66;\n  background: #f4f9f4;\n  border-left: 3px solid #5cb85c;\n  padding: 8px 10px;\n  border-radius: 0 3px 3px 0;\n}\n\n.fh-btn {\n  background: #5cb85c;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.fh-btn:hover {\n  background: #3f9c40;\n}\n\n.fh-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  background: #7aa86a;\n}\n\n.fh-btn:disabled:hover {\n  background: #7aa86a;\n}\n\n.fh-btn.ghost {\n  background: #fff;\n  color: #1c6fae;\n  border: 1px solid #e3e7eb;\n}\n\n.fh-btn.ghost:hover {\n  background: #f5f8fa;\n}\n\n.fh-btn.sm {\n  padding: 5px 12px;\n  font-size: 11px;\n}\n\n.fh-seg {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.fh-seg button {\n  flex: 1;\n  padding: 6px 0;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid #e3e7eb;\n  background: #fff;\n  color: #5c6a76;\n}\n\n.fh-seg button.on {\n  background: #2b3945;\n  color: #fff;\n  border-color: #2b3945;\n}\n\n.fh-bar-row {\n  margin-bottom: 9px;\n}\n\n.fh-bar-row-clickable {\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 4px 4px 6px;\n  margin-left: -4px;\n  margin-right: -4px;\n}\n\n.fh-bar-row-clickable:hover {\n  background: #f5f8fa;\n}\n\n.fh-bar-top {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11.5px;\n  margin-bottom: 3px;\n}\n\n.fh-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 11.5px;\n  color: #5c6a76;\n}\n\n.fh-legend span {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.fh-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.fh-camp {\n  position: relative;\n  background: linear-gradient(155deg, #24313d 0%, #3a5163 55%, #466275 100%) !important;\n  color: #fff !important;\n  border: none !important;\n  overflow: hidden;\n}\n\n.fh-camp .fh-card-title,\n.fh-camp .fh-card-sub {\n  color: #fff !important;\n}\n\n.fh-camp .fh-card-sub {\n  opacity: 0.65;\n}\n\n.fh-camp-slider {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n  animation: fhCampFade 0.35s ease;\n}\n\n@keyframes fhCampFade {\n  from {\n    opacity: 0.35;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* Fixed image slot on the right; remaining width for text */\n.fh-camp-hero {\n  position: relative;\n  flex: 0 0 300px;\n  width: 300px;\n  height: 200px;\n  min-width: 300px;\n  min-height: 200px;\n  max-width: 300px;\n  max-height: 200px;\n  align-self: center;\n  border-radius: 8px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #4d6578, #2f4252);\n}\n\n.fh-camp-hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n}\n\n.fh-camp-hero-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: rgba(255, 255, 255, 0.55);\n  background:\n    radial-gradient(circle at 30% 30%, rgba(143, 209, 143, 0.25), transparent 55%),\n    linear-gradient(135deg, #4d6578, #2f4252);\n}\n\n.fh-camp-cat {\n  display: inline-flex;\n  align-self: flex-start;\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: rgba(20, 28, 36, 0.72);\n  backdrop-filter: blur(4px);\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #b7e0b7;\n  white-space: nowrap;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fh-camp .fh-card-head {\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.fh-camp .fh-card-head-action {\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n\n.fh-camp-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 3;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(20, 28, 36, 0.65);\n  color: #fff;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.fh-camp-arrow:hover {\n  background: rgba(20, 28, 36, 0.9);\n}\n\n.fh-camp-arrow.left {\n  left: 4px;\n}\n\n.fh-camp-arrow.right {\n  right: 4px;\n}\n\n.fh-camp-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.fh-camp-slide-title {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin-bottom: 4px;\n  flex: 0 0 auto;\n}\n\n.fh-camp-desc {\n  margin: 0 0 8px;\n  font-size: 11.5px;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.72);\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow-y: auto;\n  overflow-x: hidden;\n  word-break: break-word;\n  white-space: pre-wrap;\n  overscroll-behavior: contain;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.28);\n    border-radius: 3px;\n  }\n}\n\n.fh-camp-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n  flex: 0 0 auto;\n  margin-top: auto;\n}\n\n.fh-camp-chip {\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  text-transform: capitalize;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.fh-camp-dots {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0;\n}\n\n.fh-camp-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  border: none;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.28);\n  cursor: pointer;\n  transition: width 0.2s ease, background 0.2s ease;\n}\n\n.fh-camp-dot.on {\n  background: #8fd18f;\n  width: 16px;\n  border-radius: 999px;\n}\n\n.fh-camp-cta {\n  margin-top: auto;\n  width: 100%;\n}\n\n.fh-camp ul {\n  list-style: none;\n  margin: 8px 0 10px;\n  padding: 0;\n  font-size: 12px;\n}\n\n.fh-camp li {\n  padding: 4px 0;\n}\n\n.fh-camp li::before {\n  content: \"✓\";\n  color: #8fd18f;\n  font-weight: 700;\n  margin-right: 8px;\n}\n\n.fh-veh {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 0;\n  border-top: 1px solid #e3e7eb;\n}\n\n.fh-veh:first-of-type {\n  border-top: none;\n}\n\n.fh-plate {\n  font-family: Consolas, monospace;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border: 1px solid #e3e7eb;\n  border-radius: 3px;\n  padding: 4px 8px;\n  background: #fbfcfd;\n  min-width: 84px;\n  text-align: center;\n}\n\n.fh-plate.used {\n  border-color: #cbe6cb;\n  background: #f2f9f2;\n  color: #3f9c40;\n}\n\n.fh-sev {\n  width: 6px;\n  height: 34px;\n  border-radius: 3px;\n  flex: none;\n}\n\n.fh-empty {\n  color: #8a97a3;\n  font-size: 12px;\n  padding: 12px 0;\n  text-align: center;\n}\n\n.fh-coming-soon {\n  font-size: 11px;\n  color: #8a97a3;\n  background: #f5f7f9;\n  border: 1px dashed #d5dde5;\n  border-radius: 4px;\n  padding: 8px 10px;\n  margin-top: 8px;\n  text-align: center;\n}\n\n@media (max-width: 1250px) {\n  .fh-row-score,\n  .fh-row-kpi,\n  .fh-row-lists {\n    height: auto;\n    max-height: none;\n  }\n\n  .fh-row > .fh-card {\n    max-height: none;\n  }\n\n  .fh-row-lists > .fh-card {\n    max-height: 320px;\n  }\n\n  .fh-span-3,\n  .fh-span-4,\n  .fh-span-5 {\n    grid-column: span 6;\n  }\n  .fh-span-7 {\n    grid-column: span 12;\n  }\n}\n\n@media (max-width: 768px) {\n  .fh-row-lists > .fh-card {\n    max-height: 300px;\n  }\n\n  .fh-span-3,\n  .fh-span-4,\n  .fh-span-5,\n  .fh-span-7 {\n    grid-column: span 12;\n  }\n}\n\n/* Push footer meta rows to the bottom of equal-height cards */\n.fh-row-score .fh-metaline:first-of-type {\n  margin-top: auto;\n}\n\n/* KPI row: shared visual + meta alignment across 4 cards */\n.fh-row-kpi .fh-card-head {\n  min-height: 44px;\n}\n\n.fh-row-kpi .fh-card-sub {\n  min-height: 28px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n\n.fh-row-kpi .fh-kpi-visual {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.fh-row-kpi .fh-kpi-visual--stack {\n  align-items: stretch;\n  justify-content: center;\n  width: 100%;\n}\n\n.fh-row-kpi .fh-kpi-visual--stack .fh-kpi {\n  font-size: 26px;\n}\n\n.fh-row-kpi .fh-kpi-spark {\n  width: 100%;\n  margin-top: 8px;\n  flex: 0 0 auto;\n}\n\n.fh-row-kpi .fh-kpi-range {\n  display: flex;\n  justify-content: space-between;\n  font-size: 10.5px;\n  color: #8a97a3;\n  margin-top: 6px;\n}\n\n.fh-row-kpi .fh-kpi-meta {\n  margin-top: auto;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.fh-row-kpi .fh-legend {\n  width: 100%;\n}\n\n.fh-veh-list,\n.fh-maint-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.fh-row-score .fh-card-body,\n.fh-row-kpi .fh-card-body,\n.fh-row-lists .fh-card-body {\n  overflow: hidden;\n}\n\n.fh-row-lists .fh-camp-slider,\n.fh-row-score .fh-camp-slider {\n  overflow: hidden;\n}\n\n.fh-row-lists .fh-camp-hero,\n.fh-row-score .fh-camp-hero {\n  flex: 0 0 300px;\n  width: 300px;\n  height: 200px;\n}\n\n@media (max-width: 768px) {\n  .fh-camp-slider {\n    flex-direction: column;\n  }\n\n  .fh-camp-hero {\n    flex: 0 0 300px;\n    width: 300px;\n    height: 200px;\n    align-self: flex-end;\n  }\n}\n\n.fh-row-score .fh-kpi {\n  font-size: 26px;\n}\n\n.fh-row-score .fh-metaline {\n  padding: 4px 0;\n}\n\n.fh-row-score .fh-score-layout {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  gap: 14px;\n  align-items: center;\n}\n\n.fh-row-score .fh-score-bars {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 6px;\n}\n\n/* PM Compliance — 2 metrics per row */\n.fh-pm-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 10px;\n}\n\n.fh-pm-grid .fh-metaline {\n  min-width: 0;\n  gap: 4px;\n  padding: 4px 0;\n}\n\n.fh-pm-grid .fh-metaline span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
